import script from "./TgMsgWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./TgMsgWindow.vue?vue&type=script&lang=ts&setup=true"

import "./TgMsgWindow.vue?vue&type=style&index=0&id=7147a826&lang=css"

const __exports__ = script;

export default __exports__